import {useModal} from '@hooks';
import {useAppDispatch, withAsyncThunkErrorHandling} from '@lib/store';
import {actions} from '@lib/store/src/data/timeslots/actions';
import {OfficeWorkday, WorkspaceReservation} from '@lib/store/src/data/timeslots/apiTypes';
import {useTranslation} from 'react-i18next';
import {useEditWorkspaceReservation} from 'src/components/organisms/calendar/CalendarWeekDay/components/QuickOfficeDayButton_timeslots';
import {ModalPageBottom} from 'src/components/organisms/ModalPageBottom';

export const Footer = ({
  workday,
  workspaceReservation,
  isSaving,
  setIsSaving,
}: {
  workday: OfficeWorkday;
  workspaceReservation: WorkspaceReservation;
  isSaving: boolean;
  setIsSaving: React.Dispatch<React.SetStateAction<boolean>>;
}) => {
  const {t} = useTranslation();
  const dispatch = useAppDispatch();
  const {closeModal} = useModal();

  const editFlow = useEditWorkspaceReservation(workday, workspaceReservation);
  const isPending = workspaceReservation.status === 'InvitationPending';
  const isConfirmed = workspaceReservation.status === 'Confirmed';
  const isInvitation = workspaceReservation.invitationTo !== null;

  const rightButton: {label: string; onClick: () => void; destructive: boolean} = isPending
    ? {
        label: t('translation:Accept'),
        destructive: false,
        onClick: () => alert('TODO: accept pending invitation'),
      }
    : isConfirmed
    ? {
        label: t('workplace:DeleteBooking'),
        destructive: true,
        onClick: async () => {
          setIsSaving(true);

          const result = await dispatch(
            withAsyncThunkErrorHandling(() => actions.cancelWorkspaceReservation({workspaceReservation})),
          );

          setIsSaving(false);

          if (!result.success) {
            alert(result.result.message);
          } else {
            closeModal();
          }
        },
      }
    : {
        label: 'TODO: label',
        destructive: false,
        onClick: () => alert('TODO: handle this case'),
      };

  const leftButton: {label: string; onClick: () => void; destructive: boolean} = isInvitation
    ? {
        label: t('translation:Decline'),
        destructive: true,
        onClick: () => alert('TODO: decline pending invitation'),
      }
    : {
        label: t('Edit'),
        destructive: false,
        onClick: () => {
          editFlow.openModal();
        },
      };

  return (
    <ModalPageBottom
      // Right button
      buttonLabel={rightButton.label}
      buttonType={rightButton.destructive ? 'primary destructive' : 'secondary'}
      buttonDisabled={isSaving}
      destructive={rightButton.destructive}
      onClick={rightButton.onClick}
      // Left button
      cancelButtonLabel={leftButton.label}
      cancelButtonType={leftButton.destructive ? 'secondary' : 'tertiary'}
      cancelButtonDisabled={isSaving}
      onCancel={leftButton.onClick}
    />
  );
};
